import React, { useState, useEffect } from 'react';
import { cn } from '../../lib/utils';

function Toast({ message, variant = 'default', open, onClose, duration = 4000 }) {
  useEffect(() => {
    if (open && duration > 0) {
      const t = setTimeout(onClose, duration);
      return () => clearTimeout(t);
    }
  }, [open, duration, onClose]);

  if (!open) return null;

  const variants = {
    default: 'bg-surface-3 border-white/10 text-ink',
    success: 'bg-brand-green/10 border-brand-green/30 text-brand-green',
    error: 'bg-red-500/10 border-red-500/30 text-red-400',
    warning: 'bg-yellow-500/10 border-yellow-500/30 text-yellow-400',
    info: 'bg-blue-500/10 border-blue-500/30 text-blue-400',
  };

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[9999] animate-slideUp">
      <div className={cn("rounded-lg border px-4 py-3 text-sm shadow-xl flex items-center gap-2", variants[variant])}>
        <span>{message}</span>
        <button onClick={onClose} className="ml-2 opacity-60 hover:opacity-100 text-sm">&times;</button>
      </div>
    </div>
  );
}

function useToast() {
  const [toast, setToast] = useState(null);
  const show = (message, variant = 'default', duration = 4000) => setToast({ message, variant, duration });
  const hide = () => setToast(null);
  return { toast, show, hide, ToastComponent: toast ? (
    <Toast message={toast.message} variant={toast.variant} open={!!toast} onClose={hide} duration={toast.duration} />
  ) : null };
}

export { Toast, useToast };
